export { default } from "./getButtonProps";
